export default "__VITE_ASSET__Dnl$NPfA__"